<section class="partners container-medium" *ngIf="initLoaded" [ngClass]="{ 'wrapper--mobile': isMobile$ | async }">
  <owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
      <div class="img-block">
        <img [src]="(isDarkMode$ | async) ? 'assets/images/landing/partners/' + i + '-dark.png' : 'assets/images/landing/partners/' + i + '.png'" alt="partners" />
      </div>
    </ng-template>
  </owl-carousel-o>
</section>
